/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../context/Filtercontext";
import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../Helpers/Input/RefactoredInput";

export default function CompaniesHead({ setFilter }) {
  const { setSearchQuery } = useContext(filtrationcontext);

  const [query, setQuery] = useState("");
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };

  const statusOptions = [
    { label: trans("ACTIVE"), value: "ACTIVE" },
    { label: trans("INACTIVE"), value: "INACTIVE" },
  ];

  const tradeOptions = [
    { label: trans("General Contractor"), value: "General Contractor" },
    { label: trans("Electrical"), value: "Electrical" },
    { label: trans("Plumbing"), value: "Plumbing" },
    { label: trans("HVAC"), value: "HVAC" },
    { label: trans("Roofing"), value: "Roofing" },
    { label: trans("Flooring"), value: "Flooring" },
    { label: trans("Painting"), value: "Painting" },
    { label: trans("Landscaping"), value: "Landscaping" },
  ];

  return (
    <>
      <div className="bg-white p-16 d-flex align-items-baseline gap-3">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />

        <InputSelect
          placeholder={trans("Status")}
          options={statusOptions}
          formstyle="flex-grow-1 text-capitalize"
          onChange={(e) => setFilter((prev) => ({ ...prev, status: e }))}
        />
        <InputSelect
          placeholder={trans("Trade")}
          options={tradeOptions}
          formstyle="flex-grow-1 text-capitalize"
          onChange={(e) => setFilter((prev) => ({ ...prev, trade: e }))}
        />
      </div>
    </>
  );
}

